// Auto-generated cornerstone translation for lt.
// Source: cornerstones/nl.js, translated via Claude on 2026-05-28T16:05:16.254644+00:00.

export const CORNERSTONES = {
  beste: {
    seo: {
      title: "Arklių valdymo programa: geriausias pasirinkimas 2026 | EquiSight",
      description: "Palyginkite arklių valdymo programas savininkams, arklidėms ir veisykloms. Sužinokite, kodėl EquiSight yra išsami programa jūsų arkliui.",
      keywords: [
        "arklių valdymo programa",
        "arklidės valdymo programa",
        "arklių žurnalo programa",
        "programa keliems arkliams valdyti",
        "kumelės nėštumo programa",
        "arklių veisyklos programa",
        "geriausia arklių valdymo programa",
      ],
    },
    hero: {
      eyebrow: "Pasirinkimo pagalba · arklių valdymo programinė įranga",
      breadcrumbLabel: "Arklių valdymo programa",
      title: "Arklių valdymo programa: išsamus pasirinkimo vadovas savininkams, arklidėms ir veisykloms.",
      intro: "Ne tik funkcijų sąrašas — sąžiningas palyginimas, pasirinkimo pagalba ir žvilgsnis į tai, ką arklių valdymo programa iš tiesų turi mokėti 2026 metais. Vienam arkliui, visai arklidei arba jūsų veisyklai.",
      pills: [
        {
          icon: "Users",
          label: "Savininkams",
        },
        {
          icon: "Building2",
          label: "Arklidėms",
        },
        {
          icon: "Baby",
          label: "Veisykloms",
        },
        {
          icon: "Share2",
          label: "Komandoms",
        },
      ],
      ctas: [
        {
          label: "Pradėkite nemokamai su 1 arkliu",
          href: "#start",
          primary: true,
        },
        {
          label: "Į palyginimo lentelę",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Kodėl arklių valdymo programa tampa vis svarbesnė.",
      lead: "Arklių valdymas praktikoje yra išsklaidytas: WhatsApp, kalendorius, Excel, nuotraukos telefone, popierinis pasas, atskiros sąskaitos ir žodiniai susitarimai. Net vienas arklys jau sukelia nepatogumų. Kai turite kelis arklius, veisyklą ar bendrą priežiūrą, atsiranda spragų, praleistų susitikimų ir nesusipratimų.",
      items: [
        "Kada buvo ta skiepijimo data?",
        "Kas sumokėjo kalviui?",
        "Kurią kumelę šiandien reikia patikrinti?",
        "Ar treneris perskaitė praėjusios savaitės instrukcijas?",
        "Ar tikrai išsaugojau tą nuotraukų dokumentą?",
        "Ar pašaro grafikas, kabantis arklidėje, vis dar aktualus?",
      ],
    },
    what: {
      title: "Kas yra arklių valdymo programa?",
      lead: "Arklių valdymo programa iš esmės yra skaitmeninis kiekvieno arklio failas. Ne išsklaidytos pastabos, o viena vieta sveikatai, treniruotėms, mitybai, dokumentams, planavimui, priminimams, išlaidoms, nuotraukoms, vaizdo įrašams ir bendrai prieigai. Visi aplink arklį mato tą pačią, naujausią informaciją.",
      targetGroupsTitle: "Kam skirta arklių valdymo programa?",
      targetGroups: [
        {
          icon: "Heart",
          title: "Privatus savininkas",
          body: "Vienas arklys, vienas failas — sveikata, planavimas ir istorija kišenėje.",
        },
        {
          icon: "Users",
          title: "Kelių arklių savininkas",
          body: "Atskiri profiliai, atskiras planavimas, bendra užduočių sąrašas visai komandai.",
        },
        {
          icon: "Building2",
          title: "Pensiono arklidė ir manegas",
          body: "Savininko prieiga, priežiūros instrukcijos, bendra darbotvarkė ir užduotys.",
        },
        {
          icon: "Baby",
          title: "Veisykla",
          body: "Kumelės ciklas, nėštumas, eržilo duomenys, kilmės medis ir kumeliuko raida.",
        },
        {
          icon: "Target",
          title: "Treneriai",
          body: "Įžvalga kiekvienam arkliui, sesijų registravimas, tikslų nustatymas, vaizdo įrašų analizė.",
        },
        {
          icon: "ClipboardList",
          title: "Profesionalai",
          body: "Kalvis, dantistas, fizioterapeutas ar veterinaras — dirba iš to paties failo.",
        },
      ],
    },
    criteria: {
      title: "Kokiems reikalavimams turi atitikti gera arklių valdymo programa?",
      lead: "Programa yra ne tik graži — ji turi veikti praktiškai kiekvieną dieną. Penki elementai, kurių negalima praleisti renkantis 2026 metais.",
      items: [
        {
          icon: "FileText",
          title: "Kiekvieno arklio failas",
          body: "Duomenys, amžius, veislė, paso informacija, savininkas, arklidė, nuotraukos ir dokumentai — visa tai susieta su vienu arklio profiliu.",
        },
        {
          icon: "Heart",
          title: "Sveikata ir priežiūra",
          body: "Skiepai, nubundavimas, kalvis, dantistas, veterinaras, gydymai, vaistai ir automatiniai priminimai prieš pasibaigiant terminui.",
        },
        {
          icon: "Activity",
          title: "Treniruotės ir pažanga",
          body: "Treniruočių registravimas, pastabos, vaizdo įrašai, varžybų rezultatai, tikslai ir pažanga pagal discipliną ar arklį.",
        },
        {
          icon: "Apple",
          title: "Mityba ir valdymas",
          body: "Pašaro grafikai, papildai, šiurkštus pašaras, svoris, kūno kondicija ir kasdienė rutina, kurią turi žinoti arklidė.",
        },
        {
          icon: "Share2",
          title: "Dalijimasis su kitais",
          body: "Prieiga savininkui, slaugytojui, treneriui, arklidės savininkui ar profesionalui — su teisių valdymu, atitinkančiu kiekvieno vaidmenį.",
        },
        {
          icon: "Calendar",
          title: "Planavimas ir priminimai",
          body: "Bendra darbotvarkė su užduotimis, automatiniais priminimais ir patvirtinimu, kad niekas nepraslystu pro pirštus.",
        },
      ],
    },
    comparison: {
      title: "EquiSight prieš kitas arklių valdymo programas.",
      lead: "Šiuo metu Olandijoje paieška rodo Stalmanager, LogMyHorse, EquineM ir Happie Horse. Kiekvienas turi savo stipriąsias puses. Lyginame dažniausiai prašomas funkcijas šalia viena kitos — sąžiningai ir remiantis viešai prieinama informacija.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "LogMyHorse",
        "EquineM",
        "Happie Horse",
      ],
      rows: [
        {
          label: "Nemokamas pradėjimas",
          values: [
            true,
            true,
            true,
            false,
            true,
          ],
        },
        {
          label: "Keli arkliai",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Sveikatos failas",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Treniruotės ir pažanga",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mityba ir papildai",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Planavimas ir priminimai",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dokumentai kiekvienam arkliui",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Dalijimasis su komanda ir teisės",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Veisyklos modulis (pilnas)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kumelės ciklas",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Nėštumo planavimas ir echoskopija",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kumeliuko raida",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Profesionalų integracija",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "EquiCoach įžvalgos",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tinka savininkui",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Tinka veisyklai",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tinka arklidei / manegeui",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Palyginimas remiantis viešai prieinamomis funkcijomis 2026 m. sausį. Konkurentai taip pat yra geri įrankiai; EquiSight sukurtas sujungti visus modulius vienoje programoje.",
    },
    why: {
      title: "Kodėl EquiSight yra kitokia.",
      lead: "Žurnalas registruoja. EquiSight sujungia arklių valdymą, treniruotes, mitybą, sveikatą, varžybas, profesionalus ir veisyklą vienoje modernioje programoje — ir žingsniu toliau su įžvalgomis.",
      points: [
        {
          icon: "Heart",
          title: "Viena programa visam arklio gyvenimui",
          body: "Nuo kumeliuko iki sportinio arklio, veislinės kumelės ar pensionuoto arklio. Failas auga kartu su jūsų arkliu — niekas nedingsta pakeliui.",
        },
        {
          icon: "Sparkles",
          title: "Ne tik duomenys, bet ir modeliai",
          body: "EquiCoach sujungia raidą, pasikartojančius nusiskundimus, treniruotes ir mitybą — kad laiku pastebėtumėte signalus, o ne atskirus pranešimus.",
        },
        {
          icon: "Share2",
          title: "Sukurta bendradarbiavimui",
          body: "Savininkas, arklidės savininkas, treneris, kalvis ir kiti profesionalai dirba iš to paties arklio failo — su teisėmis, atitinkančiomis jų vaidmenį.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Niša · veisykla",
      title: "Arklių valdymas veisykloms.",
      lead: "Dauguma konkurentų veisyklą pamini viena eilute. EquiSight sukūrė išsamų veisyklos modulį — nes veisėjas retai yra bendrosios programos galutinis vartotojas, tačiau planavimas jam reikalingas labiau nei bet kam kitam.",
      items: [
        "Kasdien sekti kumelės ciklą",
        "Apvaisinimo data ir eržilo duomenys",
        "Nėštumo kontrolė su echoskopija",
        "Numatoma kumeliuko gimimo data ir įspėjimai",
        "Kumeliuko raida kas mėnesį",
        "Kilmės medis ir genealogija",
        "Pastabos kiekvienai kumelei",
        "Visų nėščių kumelių apžvalga",
      ],
      ctaLabel: "Žiūrėti veisyklos modulį",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Niša · arklidė ir manegas",
      title: "Arklių valdymas keliems arkliams ir pensiono arklidėms.",
      lead: "Kai turite kelis arklius, svarbiau ne duomenys, o komunikacija. Kiekvienas savininkas turi savo pageidavimus, rutinas, pašaro susitarimus ir medicininius poreikius. Kiekvienas darbuotojas turi turėti prie jų prieigą be ieškojimo.",
      cards: [
        {
          t: "Arkliai pagal savininką",
          d: "Kiekvienas savininkas mato tik savo arklį (-ius).",
        },
        {
          t: "Priežiūros instrukcijos",
          d: "Matomos kiekvienam arkliui arklidėje.",
        },
        {
          t: "Bendra darbotvarkė",
          d: "Kalvis, veterinaras ir varžybos viename rodinyje.",
        },
        {
          t: "Užduočių sąrašas",
          d: "Priskiriamas darbuotojams su patvirtinimu.",
        },
        {
          t: "Savininko prieiga",
          d: "Klientai mato savo arklį savo programoje.",
        },
        {
          t: "Pagalbos kontaktai",
          d: "Visada randami stresinėse situacijose arklidėje.",
        },
      ],
      ctaLabel: "Žiūrėti maneго modulį",
      ctaHref: "/manege-module",
    },
    beforeAfter: {
      title: "Nuo WhatsApp, Excel ir lentos iki EquiSight.",
      lead: "Konkrečiai: taip keičiasi jūsų kasdieninė arklių priežiūra.",
      rows: [
        {
          before: "WhatsApp grupės",
          after: "Struktūrizuotos pastabos kiekvienam arkliui",
        },
        {
          before: "Excel lentelės",
          after: "Gyvas arklio failas su istorija",
        },
        {
          before: "Lenta arklidėje",
          after: "Bendra darbotvarkė jūsų telefone",
        },
        {
          before: "Atskiros nuotraukos fotoaparate",
          after: "Medija susieta su jūsų arkliu",
        },
        {
          before: "Žodiniai susitarimai",
          after: "Užduotys ir priminimai su patvirtinimu",
        },
        {
          before: "Pamestas popierinis pasas",
          after: "Dokumentai visada po ranka",
        },
      ],
    },
    helper: {
      title: "Kuri arklių valdymo programa tinka jums?",
      lead: "Atsakykite į šiuos 5 klausimus ir gausite sąžiningą rekomendaciją — net jei ji ne visada bus EquiSight.",
      questions: [
        {
          id: "horses",
          q: "Ar turite vieną arklį ar kelis?",
          options: [
            {
              label: "Vieną arklį",
              score: 1,
            },
            {
              label: "2–5 arklius",
              score: 2,
            },
            {
              label: "Daugiau nei 5 arklius",
              score: 3,
            },
          ],
        },
        {
          id: "clients",
          q: "Ar valdote klientų ar trečiųjų šalių arklius?",
          options: [
            {
              label: "Ne, tik savo arklius",
              score: 0,
            },
            {
              label: "Kartais — šeimos ar pažįstamų",
              score: 1,
            },
            {
              label: "Taip, profesionaliai (arklidė / manegas)",
              score: 3,
            },
          ],
        },
        {
          id: "breeding",
          q: "Ar norite sekti veisybą ir nėštumą?",
          options: [
            {
              label: "Neaktualu",
              score: 0,
            },
            {
              label: "Kartais — atsitiktinė veisyba",
              score: 1,
            },
            {
              label: "Taip, esu (arba tapsiu) veisėjas",
              score: 3,
            },
          ],
        },
        {
          id: "collab",
          q: "Ar bendradarbiaujate su treneriu, slaugytoju ar profesionalu?",
          options: [
            {
              label: "Ne, viską darau pats (-i)",
              score: 0,
            },
            {
              label: "Taip, su 1 asmeniu",
              score: 1,
            },
            {
              label: "Taip, su keliais asmenimis",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Ar norite tik registruoti, ar taip pat gauti įžvalgų?",
          options: [
            {
              label: "Tik registruoti",
              score: 1,
            },
            {
              label: "Registruoti ir planuoti",
              score: 2,
            },
            {
              label: "Registruoti, planuoti ir gauti įžvalgų",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Paprastas žurnalas pakanka — ir auga kartu su jumis.",
          body: "Vienam arkliui be bendros priežiūros tinka bet kuri arklių valdymo programa. EquiSight pradeda nemokamai su 1 arkliu, todėl jokios rizikos. Jei vėliau norėsite pridėti daugiau arklių, trenerį ar veisyklą, viskas jau bus pasirengta.",
          cta: "Pradėkite nemokamai su 1 arkliu",
        },
        mid: {
          title: "EquiSight puikiai tinka jūsų situacijai.",
          body: "Turite kelių poreikių (keli arkliai, bendradarbiavimas ar įžvalgos). Dauguma konkurentų apima 1–2 modulius; EquiSight juos sujungia vienoje programoje, nereikalaujant atskirų įrankių.",
          cta: "Peržiūrėkite, ką gali EquiSight",
        },
        high: {
          title: "EquiSight yra logiškiausias pasirinkimas.",
          body: "Jūsų situacija apjungia kelis arklius, bendradarbiavimą, veisyklą ir (arba) įžvalgas. Tai yra tiksliai ten, kur EquiSight daro skirtumą — jokių išsklaidytų įrankių, tik vienas arklio failas viskam ir visiems aplink arklį.",
          cta: "Pradėkite nemokamai su EquiSight",
        },
      },
    },
    faqTitle: "Dažniausiai užduodami klausimai apie arklių valdymo programas",
    faq: [
      {
        q: "Kuri arklių valdymo programa yra geriausia?",
        a: "Geriausia arklių valdymo programa priklauso nuo jūsų situacijos. Paprastam žurnalui tinka kelios programos. Jei norite sujungti sveikatą, treniruotes, mitybą, dokumentus, veisyklą, planavimą ir bendradarbiavimą, EquiSight sukurtas kaip išsamus sprendimas, kuriame viskas susirenka viename faile.",
      },
      {
        q: "Ar galiu valdyti kelis arklius vienoje programoje?",
        a: "Taip. Gera arklių valdymo programa turi palaikyti kelis arklius, įskaitant savininkus, slaugytojus, rutinas, dokumentus, susitikimus ir priminimus kiekvienam arkliui. EquiSight sukurtas pagal šį principą nuo pirmosios kodo eilutės — arkliai yra atskiri failai, o ne eilutės sąraše.",
      },
      {
        q: "Ar EquiSight tinka ir veisykloms?",
        a: "Taip. EquiSight galima sukonfigūruoti su veisyklos funkcijomis: kumelės ciklu, apvaisinimo data, nėštumo kontrole, eržilo duomenimis, kilmės medžiu, numatoma kumeliuko gimimo data ir kumeliuko raida. Tai yra būtent sritis, kurioje dauguma konkuruojančių programų nedalyvauja arba dalyvauji minimaliai.",
      },
      {
        q: "Ar galiu dalytis duomenimis su savo treneriu ar kalviu?",
        a: "Taip. EquiSight tikslas — saugiai dalytis aktualia informacija su žmonėmis aplink arklį: treneriu, kalviu, dantisto, veterinaru, fizioterapeutu, slaugytoju ar savininku. Kiekvienas asmuo gauna tik tas teises, kurios reikalingos jo vaidmeniui.",
      },
      {
        q: "Kodėl ne tiesiog naudoti WhatsApp ar Excel?",
        a: "WhatsApp ir Excel veikia tol, kol viskas paprasta. Kai turite kelis arklius, susitikimus, dokumentus, gydymus, savininkus ar veisyklos duomenis, tai tampa klaidų šaltiniu: informacija išsisklaido, paieška užima laiko, o žodiniai susitarimai dingsta. Arklių valdymo programa sujungia viską pagal kiekvieną arklį su automatiniais priminimais.",
      },
      {
        q: "Kiek kainuoja EquiSight?",
        a: "Galite pradėti nemokamai su 1 arkliu. Jei norite valdyti kelis arklius, aktyvuoti veisyklą ar suteikti prieigą profesionalams, yra prieinami Premium planai. Peržiūrėkite aktualias pasiūlymus kainų puslapyje.",
      },
    ],
  },
  fokkerij: {
    seo: {
      title: "Žirgų veisybos programinė įranga: pilna 2026 m. palyginimas",
      description: "Palyginkite žirgų veisybos programinę įrangą: kliūvio ciklą, nešumą, žirgų pasirinkimą ir kumeliukus. Sužinokite, kodėl EquiSight yra pilna veisybos programa.",
      keywords: [
        "žirgų veisybos programinė įranga",
        "kliūvio ciklo programa",
        "kliūvio nešumo programa",
        "kumeliuko registracijos programa",
        "giminės knygos programa žirgams",
        "dekvalės planavimas žirgams",
        "žirgų pasirinkimo programa",
      ],
    },
    hero: {
      eyebrow: "Pasirinkimo pagalba · veisybos programinė įranga",
      breadcrumbLabel: "Veisybos programinė įranga",
      title: "Žirgų veisybos programinė įranga: pilna 2026 m. palyginimas.",
      intro: "Veisybos kliūvis nusipelno daugiau nei bendrinės žirgų valdymo programa. Palyginkite žinomiausiųjų įrankių veisybos funkcijas, sužinokite, iš tiesų reikalingus dalykus, ir sąmoningai pasirinkite programinę įrangą, tinkančią jūsų ūkiui — didelei ar mažai.",
      pills: [
        {
          icon: "Baby",
          label: "Kliūvio ciklas",
        },
        {
          icon: "Heart",
          label: "Nešumo kontrolė",
        },
        {
          icon: "Sparkles",
          label: "Kumeliuko raida",
        },
        {
          icon: "FileText",
          label: "Giminės knyga",
        },
      ],
      ctas: [
        {
          label: "Pradėkite nemokamai su veisybos moduliu",
          href: "#start",
          primary: true,
        },
        {
          label: "Į palyginimo lentelę",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Kodėl bendrinė žirgų valdymo programa nepakanka veisybai.",
      lead: "Dauguma žirgų sporto programų skirtos vienam sport arba rekreacijos žirgui. Veisybos ūkis turi visai kitą ritmą: puffavimą, inseminaciją, nešumo kontrolę, ultragarso tyrimus, kumeliuko grafiką, giminės medį ir pardavimą. Viena Excel programa supainioja per 2 sezonus — o keliems kliūviams nutrūksta ryšys.",
      items: [
        "Kada buvo paskutinis Bonitos ciklus?",
        "Kuris žirgas planuojamas dekvalei kitą sezoną?",
        "Ar jau suplanuota 21-ųjų dienų ultragarsinė kontrolė?",
        "Kurie 2024 m. kumeliukai jau parduoti?",
        "Kur yra giminės medis iki motinos tėvo tėvo?",
        "Kur yra DNR mėginiai ir pasportiniai duomenys?",
      ],
    },
    what: {
      title: "Kas yra žirgų veisybos programinė įranga?",
      lead: "Veisybos programinė įranga yra specializuotas failas kiekvienam kliūviui ir žirgui, sujungtas su veisybos metų kalendoriumi, nešumo planavimu, kumeliuko registracija ir giminės medžio vaizdu. Ne bendrinė žirgų diarija, bet įrankis, kuris supranta veisybos ciklą: nuo pirmo puffavimo iki atsviesčio.",
      targetGroupsTitle: "Kokiam veisybos ūkio tipui skirta veisybos programinė įranga?",
      targetGroups: [
        {
          icon: "Baby",
          title: "Hobio veisėjas (1-3 kliūviai)",
          body: "Viena ar dvi dekvalės per metus — apžvalga be Excel akrobatikos.",
        },
        {
          icon: "Building2",
          title: "Mažas ūkis (4-10 kliūvių)",
          body: "Veisybos metų planas su ciklu, inseminacija, nešumo kontrolėmis ir kumeliuko failu.",
        },
        {
          icon: "Users",
          title: "Profesionalus ūkis (10+)",
          body: "Keli darbuotojai, žirgo pasirinkimas kiekvienam kliūviui, pardavimas ir marketingas.",
        },
        {
          icon: "Target",
          title: "Žirgo augintojas",
          body: "Užsakymų istorija, spermos statistika ir grafikas kiekvienam žirgui.",
        },
        {
          icon: "Heart",
          title: "Embriono transplantacija",
          body: "Donorinė ir priėmuojanti kliūvė kaip susieti failai, ET grafikas.",
        },
        {
          icon: "ClipboardList",
          title: "Giminės knygos registracija",
          body: "DNR mėginiai, pasportiniai dokumentai ir giminės medžio duomenys.",
        },
      ],
    },
    criteria: {
      title: "Kam turi atitikti geroji veisybos programinė įranga?",
      lead: "Ne kiekviena 'veisybos funkcija' žirgų programoje yra ta pati. Penki pagrindiniai sritys, kuriose veisėjai praranda daug laiko — ir kuriose programinė įranga iš tikrųjų pasikeitė.",
      items: [
        {
          icon: "Calendar",
          title: "Kliūvio ciklas ir puffavimas",
          body: "Kasdieninis žurnalas, numatoma ovulacija, ciklo slinkimas ir automatiniai priminiai.",
        },
        {
          icon: "Heart",
          title: "Inseminacija ir nešumo kontrolė",
          body: "Dekvalės ir inseminacijos datos, žirgo duomenys, 14-ųjų dienų ultragarso, 21-ųjų dienų ultragarso, 60-ųjų dienų ultragarso ir lyties nustatymas.",
        },
        {
          icon: "Baby",
          title: "Kumeliuko raida",
          body: "Gimimo duomenys, svorio grafikas, kirmų naikinimo grafikas, atsviesčio momentas, pasportine registracija.",
        },
        {
          icon: "FileText",
          title: "Giminės medis ir popieriniai dokumentai",
          body: "Giminės medžio vaizdas iki 4-5 kartų, DNR, pasparto numeriai ir giminės knygos statusas.",
        },
        {
          icon: "Target",
          title: "Žirgo pasirinkimas ir derimas",
          body: "Filtravimas pagal discipliną, linijas, žirgo duomenis ir istorinį sėkmę — ne tik tai, ką žirgo augintojas stumia.",
        },
        {
          icon: "Share2",
          title: "Bendradarbiavimas su veterinaru/inseminatoriumi",
          body: "Ultragarso tyrimai, mėginiai ir statusai tiesiogiai bendrinami su praktika, dirbančia su jūsų kliūviais.",
        },
      ],
    },
    comparison: {
      title: "EquiSight ir kita veisybos programinė įranga.",
      lead: "Holandiškoje SERP veisybos programinei įrangai dažnai rodomi bendrinės žirgų programos, kurios veisybą pamini vieno sakinio. Sąžiningai palyginame, kurie įrankiai tikrai turi pilną veisybos srautą.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "HorseManager",
        "EquineGenie",
        "Foal-Excel",
      ],
      rows: [
        {
          label: "Nemokas pradžia",
          values: [
            true,
            true,
            false,
            false,
            true,
          ],
        },
        {
          label: "Kliūvio ciklo žurnalų vedimas",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Inseminacijos data + žirgas",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ultragarso tyrimai ir nešumo kontrolė",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Numatyta kumeliuko gimimo data",
          values: [
            true,
            false,
            true,
            true,
            true,
          ],
        },
        {
          label: "Kumeliuko failas (svoris/augimas)",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Giminės medis iki 4-5 kartų",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "DNR ir pasportine registracija",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Žirgo pasirinkimas / derimas",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "ET / embriono transplantacija",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Kelių kliūvių apžvalga",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Mobilas (iOS/Android)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Dalyvavimas su veterinaru",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integruotas su bendra programa",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kumeliukų pardavimas ir marketingas",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
      ],
      note: "Palyginimas remiantis viešai prieinomomis funkcijomis 2026 m. sausio mėnesį. EquineGenie stipri veisyboje, tačiau mažiau mobili + bendrinė žirgų valdymo. EquiSight sujungia abu.",
    },
    why: {
      title: "Kodėl EquiSight veisėjams tarnauja kitaip.",
      lead: "Daug veisėjų dirba su atskira veisybos programine įranga ir atskira žirgų vadybos programa. EquiSight sujungia abi — nereikia keistis tarp programų ar dvigubai įvesti duomenų.",
      points: [
        {
          icon: "Heart",
          title: "Veisybos kliūvis lieka paprastu žirgu",
          body: "Veisybos kliūvis turi veisybos metų ir paprastą žirgo failą — sveikata, skiepai, paduvenės. Viena programa, visos modulės.",
        },
        {
          icon: "Sparkles",
          title: "Numatomas, o ne reaktyvus",
          body: "Ciklo prognozė, nešumo etapų priminiai ir kumeliuko grafikas — automatiškai pagal jūsų duomenis.",
        },
        {
          icon: "Share2",
          title: "Visi aplink veisybą",
          body: "Inseminatorius, žirgo augintojas, veterinaras, pirkėjas, giminės knyga — visi turi prieigą su tinkamomis teisėmis.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Per discipliną · ciklą iki atsviesčio",
      title: "Kas yra veisybos failas EquiSight.",
      lead: "Kiekvienam kliūviui gausite pilną veisybos failą, susietu su jos paprastu žirgo failu.",
      items: [
        "Kasdieninis ciklo žurnalas su prognoze",
        "Inseminacija/dekvalė + žirgo duomenys",
        "Ultragarso seka (14/21/60 dienų + lytis)",
        "Nešumo etapai su automatiniais primyniais",
        "Numatyta kumeliuko gimimo data ir pasiruošimas",
        "Kumeliuko failas nuo gimimo",
        "Giminės medis iki tėvo/motinos kliko navigacija",
        "DNR mėginys, pasportas, giminės knygos statusas",
        "Pardavimo konvejeris su susidomėjusiais",
        "Žirgo pasirinkimo istorija kiekvienam kliūviui",
      ],
      ctaLabel: "Peržiūrėkite veisybos modulį",
      ctaHref: "/fokkerij",
    },
    nicheB: {
      eyebrow: "Visam ūkiui",
      title: "Apžvalga keliems kliūviams ir žirgams.",
      lead: "Kai veisite daugiau nei 2-3 kliūvius, apžvalga apie visus ciklus ir nešumus tampa svarbi.",
      cards: [
        {
          t: "Ciklo sritis",
          d: "Visi kliūviai greta su ciklo stadija ir kitu žingniu.",
        },
        {
          t: "Nešumo konvejeris",
          d: "Kurie kliūviai yra kur nešumo etapuose?",
        },
        {
          t: "Kumeliuko grafikas",
          d: "Numatyti gimtuvai per mėnesį, su logistika.",
        },
        {
          t: "Žirgo portfelis",
          d: "Savas žirgai ar pastovūs inseminatoriai su užsakymų istorija.",
        },
        {
          t: "Giminės medžio grafikas",
          d: "Pirmtakų analizė keletas kartų ir linijas.",
        },
        {
          t: "Pardavimo sritis",
          d: "Kurie kumeliukai parduoti, rezervuoti ar dar prieinami.",
        },
      ],
    },
    beforeAfter: {
      title: "Nuo Excel + kalendoriaus iki EquiSight veisybos.",
      lead: "Konkrečiai: kaip keičiasi jūsų veisybos sezonas.",
      rows: [
        {
          before: "Ciklas atskirame užraše",
          after: "Kasdieninis žurnalas su prognoze",
        },
        {
          before: "Ultragarso per WhatsApp inseminatoriui",
          after: "Bendras failas su nuotraukomis",
        },
        {
          before: "Nešumo data kalendoriuje",
          after: "Automatiniai etapų priminiai",
        },
        {
          before: "Kumeliuko pasportas stalčiuje",
          after: "Dokumentas, susietas su kumeliuko profiliu",
        },
        {
          before: "Giminės medis ant popieriaus",
          after: "Klikalus giminės medis iki 4-5 kartų",
        },
        {
          before: "Pardavimo skelbimai Marktplaatse",
          after: "Pardavimo konvejeris su susidomėjusiais",
        },
      ],
    },
    helper: {
      title: "Kuri veisybos programinė įranga tau tinka?",
      lead: "5 klausimai, kad patikrintum, ar tau reikalinga pilna veisybos programa, ar hobio įrankis pakaks.",
      questions: [
        {
          id: "mares",
          q: "Kiek veisybos kliūvių tu valdai?",
          options: [
            {
              label: "1 kliūvis",
              score: 1,
            },
            {
              label: "2-5 kliūviai",
              score: 2,
            },
            {
              label: "Daugiau nei 5 kliūviai",
              score: 3,
            },
          ],
        },
        {
          id: "frequency",
          q: "Kaip dažnai tu vaiši per metus?",
          options: [
            {
              label: "Retai (per keletą metų)",
              score: 0,
            },
            {
              label: "Kiekvienais metais 1-2 dekvalės",
              score: 2,
            },
            {
              label: "Kiekvienais metais 3+ dekvalės",
              score: 3,
            },
          ],
        },
        {
          id: "method",
          q: "Kaip tu inseminuoji/dekvalei?",
          options: [
            {
              label: "Natūrali dekvalė",
              score: 1,
            },
            {
              label: "KI šviežios/atvėsintos spermos",
              score: 2,
            },
            {
              label: "ET arba giliai užšaldyta",
              score: 3,
            },
          ],
        },
        {
          id: "team",
          q: "Ar tu bendradarbiauti su veterinaru/inseminatoriumi?",
          options: [
            {
              label: "Vienas pastovus žmogus",
              score: 1,
            },
            {
              label: "Kelios praktikos",
              score: 2,
            },
            {
              label: "Tarptautinis tinklas",
              score: 3,
            },
          ],
        },
        {
          id: "tracking",
          q: "Ką tu dabar sekei?",
          options: [
            {
              label: "Excel arba popierius",
              score: 1,
            },
            {
              label: "Bendrinė žirgų valdymo programa",
              score: 2,
            },
            {
              label: "Niekas struktūruotai",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Hobio įrankis arba Excel pakaks — bet EquiSight lieka naudingas.",
          body: "Vienam kliūviui su natūralia dekva kas porą metų nereikalinga išplėtota veisybos modulė. EquiSight prasideda nemokamai ir aktyvinsi veisybos modulį tik metams, kai vaiši — be atnaujinimo pareigos.",
          cta: "Pradėkite nemokamai",
        },
        mid: {
          title: "EquiSight veisybos programa yra tinkama priemonė.",
          body: "Tu turi kelis kliūvius ar kelias fokinimo metodus — bendrinės žirgų programos nėra pastatytos tam. EquiSight sujungia veisybą ir bendrąją priežiūrą, kad nereikėtų keistis tarp dviejų programų.",
          cta: "Peržiūrėkite veisybos modulį",
        },
        high: {
          title: "EquiSight pastatytas jūsų ūkiui.",
          body: "Keli kliūviai, ET arba giliai užšaldyta, tarptautinis komanda — dauguma programų čia neišsilaikys. EquiSight skalėjasi iki ūkio lygio be papildomų licencijų.",
          cta: "Pokalbi su mums apie Ūkio planą",
        },
      },
    },
    faqTitle: "Dažnai užduodami klausimai apie veisybos programinę įrangą",
    faq: [
      {
        q: "Kuri geriausia žirgų veisybos programinė įranga?",
        a: "Vienam kliūviui be sudėtingų veisybos metodų pakaks daug programų. Nuo 2-3 kliūvių, KI ar ET naudojimo, bendradarbiavimo su veterinaru ir giminės knyga, pilna veisybos modulė tampa būtina. EquiSight sujungia veisybą ir bendrąją žirgų valdymą vienoje programoje, todėl nereikia keistis.",
      },
      {
        q: "Kokios veisybos funkcijos man tikrai reikalingos?",
        a: "Minimumas: ciklo žurnalas, inseminacijos/dekvalės duomenys, nešumo kontrolės etapai ir kumeliuko failas. Pasirinktinai, bet galingas: giminės medžio vaizdas, žirgo pasirinkimo archyvas, DNR/pasportas ir pardavimo konvejeris.",
      },
      {
        q: "Ar EquiSight gali numatyti kliūvio ciklą?",
        a: "Taip. EquiSight naudoja ankstesnius ciklo duomenis ir rodo numatytą ovulaciją, todėl inseminacija ar dekvalė numatytu laiku — be kasdieninio spėliojimo.",
      },
      {
        q: "Ar EquiSight veikia embriono transplantacijai?",
        a: "Taip. Donorinė ir priėmuojanti kliūvė gaunamos susietas failus, ET grafiką ir bendrus etapus su praktika. Taigi tu neprarandai laiko sudėtingoje ET srityje.",
      },
      {
        q: "Ar galiu importuoti savo esamą veisybos duomenis?",
        a: "Tu gali rankiniu būdu įvesti ciklus, dekvales ir kumeliuko duomenis arba paketinę CSV. Jei tu turi kelis metų duomenis, galime padėti su vienkartine migracija.",
      },
      {
        q: "Kaip dalinuos failą su veterinaru ar inseminatoriumi?",
        a: "Kiekvienas žmogus gauna prieigą su vaidmeniu: veterinara, inseminatorius, žirgo augintojas arba giminės knygos funkcija. Kiekvienas mato tik jam reikalingą informaciją — nereikalinga visa prieiga.",
      },
    ],
  },
  manege: {
    seo: {
      title: "Jodininkų programinė įranga: pilnas palyginimas ir pasirinkimo pagalba 2026",
      description: "Palyginkite jodininkų programinę įrangą pamokoms, raiteliams, arkliams ir administravimui. Sužinokite, kuri programa tinka jūsų jodinėjimo mokyklai ar pensionui.",
      keywords: [
        "jodininkų programinė įranga",
        "arklidės valdymo programa",
        "jodininkų administravimo programinė įranga",
        "pamokų planavimas jodininkams",
        "arklių pensiono programinė įranga",
        "raitelių administravimas",
        "arklių administravimas jodininkams",
      ],
    },
    hero: {
      eyebrow: "Pasirinkimo pagalba · jodininkų programinė įranga",
      breadcrumbLabel: "Jodininkų programinė įranga",
      title: "Jodininkų programinė įranga: pilnas pasirinkimo vadovas jodinėjimo mokykloms ir pensionams.",
      intro: "Pamokų planavimas, raitelių administravimas, arklių valdymas, sąskaitų faktūrų išrašymas ir komunikacija — gera jodininkų programinė įranga sujungia viską. Palyginkite žinomiausias parinktis ir sužinokite, kuri tinka jūsų arklidei ar jodinėjimo mokyklai.",
      pills: [
        {
          icon: "Calendar",
          label: "Pamokų planavimas",
        },
        {
          icon: "Users",
          label: "Raiteliai ir klientai",
        },
        {
          icon: "Heart",
          label: "Arklių priežiūra",
        },
        {
          icon: "CreditCard",
          label: "Sąskaitų išrašymas",
        },
      ],
      ctas: [
        {
          label: "Užsisakykite demonstraciją",
          href: "#start",
          primary: true,
        },
        {
          label: "Į palyginimo lentelę",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Kodėl išsklaidyti įrankiai sulėtina jodinėjimo mokyklą.",
      lead: "Dauguma jodinėjimo mokyklų veikia per mozaiką: pamokų planavimas ant lentos, raitelių registracija Excel, sąskaitų išrašymas kitame įrankyje, arklių priežiūra WhatsApp, o ryšys su savininkais — asmeniniais pranešimais. Įtemptą savaitę atsiranda dvigubi užsakymai, pamirštos sąskaitos arba arkliai, nežinantys, kuris raitelis juos ims.",
      items: [
        "Kas dabar turi pamoką su Jasmijn?",
        "Kuris raitelis dar nesumokėjo už kovą?",
        "Kuris arklys šią savaitę negali būti naudojamas?",
        "Kokie yra mokinių avariniai kontaktai?",
        "Ar Stardust savininkas jau gavo kalvio sąskaitą?",
        "Kuris arklys yra kuriame aptve?",
      ],
    },
    what: {
      title: "Kas yra jodininkų programinė įranga?",
      lead: "Jodininkų programinė įranga sujungia pamokų planavimą, raitelių administravimą, arklių valdymą, sąskaitų išrašymą ir komunikaciją į vieną įrankį. Jokio Excel akrobatikos ar WhatsApp chaoso — tik viena vieta, kurioje dirba jodinėjimo mokykla, o savininkai ir raiteliai stebi.",
      targetGroupsTitle: "Kokio tipo įmonėms skirta jodininkų programinė įranga?",
      targetGroups: [
        {
          icon: "Building2",
          title: "Maža jodinėjimo mokykla (1–15 arklių)",
          body: "Visų pirma pamokų planavimas ir mokėjimai — administravimas be galvos skausmo.",
        },
        {
          icon: "Users",
          title: "Vidutinė jodinėjimo mokykla (15–40 arklių)",
          body: "Keli instruktoriai, pamokų planavimas + arklių grafikas + raitelių administravimas.",
        },
        {
          icon: "ClipboardList",
          title: "Didelė jodinėjimo ir pensiono arklidė (40+)",
          body: "Pilnas veikimas, įskaitant sąskaitų išrašymą, pašaro ir kalvio planavimą.",
        },
        {
          icon: "Heart",
          title: "Pensiono arklidė",
          body: "Savininkų portalas, individualios priežiūros instrukcijos, bendras kalendorius.",
        },
        {
          icon: "Target",
          title: "Šuolių raitelių treniruočių arklidė",
          body: "Varžybų planavimas, treniruotės kiekvienam arkliui, ryšys su klientais.",
        },
        {
          icon: "FileText",
          title: "Hipiški verslininkai",
          body: "Pamokų, pensiono, klinikų ir prekybos derinys — viskas iš vienos sistemos.",
        },
      ],
    },
    criteria: {
      title: "Kokius reikalavimus turi atitikti gera jodininkų programinė įranga?",
      lead: "Graži programa nieko nereiškia, jei jūsų darbuotojai nenori su ja dirbti. Penki praktiniai kriterijai, kurie lemia skirtumą tarp sėkmės ir nusivylimo.",
      items: [
        {
          icon: "Calendar",
          title: "Kelių lygių pamokų planavimas",
          body: "Pradedantieji/pažengę, dresūra/šuoliai, arklių–raitelių jungtys ir instruktorių kalendoriai — viską matote vienu metu.",
        },
        {
          icon: "Users",
          title: "Raitelių administravimas",
          body: "Profiliai, lygis, prenumerata, pamokų kortelė ir šeimos narių jungtys jauniesiems raiteliams.",
        },
        {
          icon: "Heart",
          title: "Arklių grafikas",
          body: "Kuris arklys kiek kartų naudojamas, su poilsio, traumų ir sezoninio poilsio laikotarpiais.",
        },
        {
          icon: "CreditCard",
          title: "Sąskaitų išrašymas ir prenumeratos",
          body: "Mėnesinės prenumeratos, pamokų kortelės, pavienės pamokos ir automatinis debeto nurašymas.",
        },
        {
          icon: "Share2",
          title: "Savininkų portalas (pensionas)",
          body: "Savininkai mato savo arklį nuosavoje programoje — kalendorius, išlaidos, kalvis ir pastabos be skambučių.",
        },
        {
          icon: "Bell",
          title: "Komunikacija ir priminimai",
          body: "Automatiniai pamokų priminimai, mokėjimo pranešimai, kalvio skelbimai — be žinučių siuntimo.",
        },
      ],
    },
    comparison: {
      title: "EquiSight vs kita jodininkų programinė įranga.",
      lead: "Daugelis jodininkų įrankių yra stiprūs pamokų planavime ar sąskaitų išrašyme, tačiau retai — arklių priežiūroje ir savininkų komunikacijoje kartu. Sąžiningai lyginame juos vienas su kitu.",
      competitors: [
        "EquiSight",
        "Stalmanager",
        "Equino",
        "Manege App",
        "Spreadsheet",
      ],
      rows: [
        {
          label: "Nemokama pradžia / bandomasis laikotarpis",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Pamokų planavimas",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Keli instruktoriai",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Raitelių administravimas",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Arklių grafikas",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Arklių priežiūra (vakcin./kalvis)",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Pamokų kortelė / prenumerata",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Mokėjimai internetu",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Automatinis sąskaitų išrašymas",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "Savininkų portalas (pensionas)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kalvio/veterinaro integracija",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "WhatsApp/SMS priminimai",
          values: [
            true,
            true,
            false,
            false,
            false,
          ],
        },
        {
          label: "Mobilusis (iOS/Android)",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Varžybų planavimas",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Tinka pensiono arklidei",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
      ],
      note: "Palyginimas pagal viešai prieinamas funkcijas 2026 m. sausio mėn. Stalmanager stiprus administravime, EquiSight išsiskiria pensiono darbo eiga + arklių priežiūra + savininkų portalu.",
    },
    why: {
      title: "Kodėl EquiSight skiriasi jodinėjimo mokykloms ir pensionams.",
      lead: "EquiSight eina toliau nei pamokų planuoklis. Jodinėjimo mokyklą matome kaip pilną operaciją: arkliai, žmonės, komunikacija ir finansai — visi tarpusavyje susiję.",
      points: [
        {
          icon: "Heart",
          title: "Arklys centre, ne kalendorius",
          body: "Kiekvienas arklys turi savo bylą. Pamokų dalyvavimas, sveikata, kalvis ir varžybos vienoje laiko juostoje — ne 3 atskiri įrankiai.",
        },
        {
          icon: "Share2",
          title: "Savininkai stebi be skambučių",
          body: "Pensiono arklidės savininkai turi savo peržiūrą: išlaidos, planavimas, nuotraukos ir pastabos — sutaupo 5–10 skambučių per savaitę.",
        },
        {
          icon: "Bell",
          title: "Automatinė komunikacija",
          body: "Pamokų priminimas, vakcinacijos priminimas, sąskaita faktūra — automatiškai, per programą/el. paštą/SMS. Daugiau jokių WhatsApp transliacijų.",
        },
      ],
    },
    nicheB: {
      eyebrow: "Pensiono arklidei",
      title: "Ką pensiono arklidė gauna su EquiSight.",
      lead: "Pensiono arklidės turi unikalių iššūkių, kurių įprasta jodininkų programinė įranga nesprendžia.",
      cards: [
        {
          t: "Savininkų portalas",
          d: "Kiekvienas savininkas mato tik savo arklį (-ius), kalendorių ir išlaidas.",
        },
        {
          t: "Priežiūros instrukcijos kiekvienam arkliui",
          d: "Pašaras, šiurkštus pašaras, priedai, antklodžių grafikas — matoma arklidės personalui.",
        },
        {
          t: "Bendras kalendorius",
          d: "Kalvis, veterinaras ir savininkų vizitai vienoje peržiūroje.",
        },
        {
          t: "Kiekvieno arklio suvartojimo išlaidos",
          d: "Pakratai, pašaras, koncentruotas pašaras perkeliami kiekvienam savininkui.",
        },
        {
          t: "Arklio avariniai kontaktai",
          d: "Savininkas, veterinaras ir kalvis visada randami arklidės personalui.",
        },
        {
          t: "Ganyklų valdymas",
          d: "Kurie arkliai eina į ganyklą, ilsisi ar reabilitaciją?",
        },
      ],
    },
    beforeAfter: {
      title: "Nuo lentos + Excel iki EquiSight.",
      lead: "Konkrečiai: taip keičiasi darbo savaitė jodinėjimo mokykloje.",
      rows: [
        {
          before: "Lenta su pamokų grafiku",
          after: "Gyvas planavimas pagal instruktorių",
        },
        {
          before: "Excel su raiteliais ir pamokų pastabomis",
          after: "Klientų CRM su pamokų istorija",
        },
        {
          before: "WhatsApp žinutės savininkams",
          after: "Savininkų portalas jų arkliui",
        },
        {
          before: "Rankinis mėnesinis debeto nurašymas",
          after: "Automatinis sąskaitų išrašymas + iDEAL",
        },
        {
          before: "Arklių priežiūra ant popieriaus skelbimų lentos",
          after: "Priežiūros instrukcijos kiekvienam arkliui, bendrai prieinamos",
        },
        {
          before: "Žodinis susitarimas su kalviu",
          after: "Kalvio planavimas su patvirtinimais",
        },
      ],
    },
    helper: {
      title: "Kuri jodininkų programinė įranga jums tinka?",
      lead: "5 klausimai, padėsiantys nustatyti, ar EquiSight yra tinkama platforma jūsų jodinėjimo mokyklai ar pensionui.",
      questions: [
        {
          id: "size",
          q: "Kiek arklių turite savo įmonėje?",
          options: [
            {
              label: "Mažiau nei 10",
              score: 1,
            },
            {
              label: "10–30",
              score: 2,
            },
            {
              label: "Daugiau nei 30",
              score: 3,
            },
          ],
        },
        {
          id: "type",
          q: "Kokia jūsų pagrindinė veikla?",
          options: [
            {
              label: "Daugiausia pamokų vedimas",
              score: 1,
            },
            {
              label: "Pensiono arklidė (arkliai pensione)",
              score: 3,
            },
            {
              label: "Pamokų ir pensiono derinys",
              score: 3,
            },
          ],
        },
        {
          id: "instructors",
          q: "Su kiek instruktorių dirbate?",
          options: [
            {
              label: "Tik aš pats",
              score: 1,
            },
            {
              label: "2–3 instruktoriai",
              score: 2,
            },
            {
              label: "4 ar daugiau",
              score: 3,
            },
          ],
        },
        {
          id: "billing",
          q: "Kaip dabar tvarkote sąskaitų išrašymą?",
          options: [
            {
              label: "Rankiniu būdu (Word/Excel)",
              score: 3,
            },
            {
              label: "Atskira apskaitos programa",
              score: 2,
            },
            {
              label: "Integruota pamokų įrankyje",
              score: 1,
            },
          ],
        },
        {
          id: "owners",
          q: "Kaip bendraujate su savininkais?",
          options: [
            {
              label: "Asmeniškai / WhatsApp",
              score: 3,
            },
            {
              label: "El. paštu + WhatsApp",
              score: 2,
            },
            {
              label: "Savininkų portalas įrankyje",
              score: 0,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Lengvas įrankis ar Excel kol kas tinka — tačiau EquiSight auga kartu su jumis.",
          body: "Mažai pamokų įmonei su vienu instruktoriumi ir nedaug pensiono išplėstas paketas dar nebūtinas. EquiSight prasideda nemokamai ir auga kartu su jūsų jodinėjimo mokykla — jokio skausmingo perkėlimo po kelių metų.",
          cta: "Pradėkite nemokamai",
        },
        mid: {
          title: "EquiSight yra logiškas atnaujinimas jūsų jodinėjimo mokyklai.",
          body: "Keli instruktoriai, pamokų ir pensiono derinys arba sąskaitų išrašymas, kuris šiuo metu yra atskirai — EquiSight sujungia tai į vieną darbo eigą. Ypač savininkų portalas sutaupo daug neplanuotos komunikacijos.",
          cta: "Užsisakykite demonstraciją",
        },
        high: {
          title: "EquiSight sukurtas jūsų masto veiklai.",
          body: "Pensionas + pamokos + keli instruktoriai — tai tiksliai ta sritis, kurioje EquiSight išsiskiria iš klasikinių jodininkų įrankių. Savininkų portalas ir arklių priežiūros integracija kasavaitinę administraciją ir komunikaciją supaprastina valandomis.",
          cta: "Planuokite demonstraciją savo arklidei",
        },
      },
    },
    faqTitle: "Dažnai užduodami klausimai apie jodininkų programinę įrangą",
    faq: [
      {
        q: "Kokia geriausia jodininkų programinė įranga?",
        a: "Vien pamokų planavimui yra keletas gerų variantų. Kai tik jums reikia pensiono, kelių instruktorių ar arklių priežiūros sekimo, EquiSight tampa pilnu sprendimu — jokio įrankių žongliravimo, viskas vienoje vietoje.",
      },
      {
        q: "Ar galiu importuoti esamus klientus ir pamokas?",
        a: "Taip. Klientų duomenis ir pamokų grafikus galite importuoti per CSV. Padedame aktyvioms jodinėjimo mokykloms atlikti vienkartinį perkėlimą, kad nereikėtų rankiniu būdu įvesti 200 raitelių.",
      },
      {
        q: "Ar veikia ir pensiono arklidei be pamokų?",
        a: "Taip. Pensiono režimas išjungia pamokas ir sutelkiasi į savininkų portalą, pašaro/priežiūros valdymą, kalvio planavimą ir išlaidų paskirstymą kiekvienam arkliui.",
      },
      {
        q: "Ar raiteliai gali patys registruotis ir mokėti?",
        a: "Taip. Raiteliai per savo paskyrą gali matyti, kurios pamokos yra laisvos, registruotis, mokėti pamokų mokestį su iDEAL ir pirkti pamokų korteles.",
      },
      {
        q: "Kaip užtikrinamas arklių ir savininkų duomenų privatumas?",
        a: "Kiekvienas asmuo turi vaidmenį (savininkas, raitelis, instruktorius, darbuotojas). Pagal vaidmenį matote tik tai, kas jums reikalinga. Savininkai mato tik savo arklį, raiteliai — tik savo pamokas.",
      },
      {
        q: "Ar EquiSight gali jungtis prie mano apskaitos programos?",
        a: "Taip, jungtys su Exact, Moneybird ir e-Boekhouden yra prieinamos. Sąskaitos faktūros tuomet automatiškai perduodamos į jūsų apskaitą.",
      },
    ],
  },
  trainer: {
    seo: {
      title: "Trenerio programa žirgui: palyginimas ir pasirinkimo vadovas treneriams 2026",
      description: "Palyginkite žirgo trenerio programas: treniruočių žurnalas, vaizdo įrašai, tikslai, protokolo analizė ir klientų valdymas. Raskite tinkamą įrankį treneriams.",
      keywords: [
        "trenerio programa žirgui",
        "instruktoriaus programa",
        "žirgo treniavimo programa",
        "žedo coachingo programa",
        "treniruočių žurnalas žirgui",
        "dresūros protokolo analizė",
        "žirgo trenerio programinė įranga",
      ],
    },
    hero: {
      eyebrow: "Pasirinkimo vadovas · trenerio programinė įranga",
      breadcrumbLabel: "Trenerio programa",
      title: "Trenerio programa žirgui: visapusus pasirinkimo vadovas instruktoriams ir treneriams.",
      intro: "Treneris arba instruktorius žongliroja kombinacijomis, pamokomis, vaizdo įrašais, tikslais ir varžybomis. Palyginkite geriausias žirgo trenerio programas ir pasirinkite platformą, kuri augs kartu su jūsų coaching 2026 metais.",
      pills: [
        {
          icon: "Target",
          label: "Tikslai ir planavimas",
        },
        {
          icon: "Video",
          label: "Vaizdo analizė",
        },
        {
          icon: "TrendingUp",
          label: "Pažanga",
        },
        {
          icon: "Users",
          label: "Klientai/kombinacijos",
        },
      ],
      ctas: [
        {
          label: "Pradėti nemokamai kaip treneris",
          href: "#start",
          primary: true,
        },
        {
          label: "Į palyginimo lentelę",
          href: "#vergelijking",
        },
      ],
    },
    pains: {
      title: "Kodėl WhatsApp coaching trenerius sulėtina.",
      lead: "Dauguma trenerių dirba su atskira įranga: WhatsApp komunikacijai, sąsiuvinys pamokomis, YouTube ar WeTransfer vaizdo failams ir Excel varžybų rezultatams. Penkiems žedams tai veikia. Dvidešimčiai žedų informacija prarandama, pamirštate tikslus ir nutrūksta ryšys su individualine pažanga.",
      items: [
        "Koks šiais metais Anouk tikslas?",
        "Kokį vaizdo failą aš praeito mėnesio pradžioje nusiuntiau Bramui?",
        "Ar Lara pamatė jos paskutinės varžybos protokolo analizę?",
        "Kuri kombinacija treniruojasi kiek kartų per savaitę?",
        "Ar Stardust savininkas perskaitė mano treniravimo instrukcijas?",
        "Kada paskutinis kartas daviau atsiliepimą apie svyruojantį impulsą?",
      ],
    },
    what: {
      title: "Kas yra trenerio programa žirgui ir žedui?",
      lead: "Trenerio programa sujungia coaching CRM (kombinacijos, pamokos, tikslai), treniravimo žurnalą kiekvienam žirgui, vaizdo atsiliepimą, varžybų planavimą ir protokolo analizę. Nebėra atskirų WhatsApp/YouTube/Excel, o viena platforma, kurioje treneris ir žedas dirba kartu.",
      targetGroupsTitle: "Kuriam trenerio tipui tai skirta?",
      targetGroups: [
        {
          icon: "Target",
          title: "Dresūros instruktorius",
          body: "Protokolo nuskaitymas, žiuri komentarų susietas su treniravimo tikslais, pažangos stebėjimas.",
        },
        {
          icon: "Activity",
          title: "Šuolių treneris",
          body: "Kliūčių planavimas, turo atsiliepimas, aukščio valdymas kiekvienam žirgui.",
        },
        {
          icon: "Award",
          title: "Trišalės varžybos koučas",
          body: "Trys disciplinos, trys planai - visos kartu matmos.",
        },
        {
          icon: "TrendingUp",
          title: "Aukšto meistriškumo koučas",
          body: "EPI sekimas, varžybos, tikslai — olimpinių sportininkų ir jų komandų.",
        },
        {
          icon: "Users",
          title: "Manėžo instruktorius",
          body: "Grupinės pamokos + individualus coaching vienoje programoje.",
        },
        {
          icon: "Heart",
          title: "Rekreacinis koučas",
          body: "Žirgo terapija, pradedantieji, savininkai su vienu žirgu.",
        },
      ],
    },
    criteria: {
      title: "Ką turėtų atlikti gera trenerio programa?",
      lead: "Treniravimas yra žmonių darbas, bet tinkamas įrankis padaro jus 30-50% efektyvesniais ir padeda žedams geriau treniruotis ir tarp pamokų.",
      items: [
        {
          icon: "Users",
          title: "Kombinacijų valdymas",
          body: "Žirgas + žedas kaip viena vienetas, su lygiu, tikslais, pažanga ir istorija.",
        },
        {
          icon: "ClipboardList",
          title: "Pamokų pastabos ir tikslai",
          body: "Kiekvienai pamokai - pastaba su fokusuotais taškais, susieta su ilgalaikiais tikslais.",
        },
        {
          icon: "Video",
          title: "Vaizdo atsiliepimas",
          body: "Nusiųsti vaizdo failą, žymėti momentus, pridėti žodžiu ar raštu atsiliepimą.",
        },
        {
          icon: "Target",
          title: "Varžybų ir protokolo analizė",
          body: "Nuskaitykite protokolus (KNHS/FEI), pamatykite taškus pagal dalį, žiuri komentarus ir tendencijas.",
        },
        {
          icon: "Calendar",
          title: "Planavimas ir pamokų kortelės",
          body: "Kalendorius, mokėjimai, abonementai ir automatiniai priminimai.",
        },
        {
          icon: "Share2",
          title: "Komunikacija žedui",
          body: "Žedas mato savo puslapį su pamokomis, vaizdo failais, tikslais ir atsiliepimais.",
        },
      ],
    },
    comparison: {
      title: "EquiSight ir kitos trenerio programos.",
      lead: "Kai kurie trenerio įrankiai sukoncentruoti į WhatsApp pakeitimą, kiti į protokolo analizę. EquiSight sujungia abi su tikru žirgo dossier — kad žedas tarp pamokų geriau treniruotųsi.",
      competitors: [
        "EquiSight",
        "Coach Apps (bendra)",
        "HorseTrainer Pro",
        "EquiPilot",
        "WhatsApp + Excel",
      ],
      rows: [
        {
          label: "Nemokamai pradėti",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Kombinacijų valdymas",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Pamokų pastabos ir atsiliepimas",
          values: [
            true,
            true,
            true,
            true,
            true,
          ],
        },
        {
          label: "Ilgalaikiai tikslai",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
        {
          label: "Vaizdo nusiuntimas ir atsiliepimas",
          values: [
            true,
            true,
            true,
            false,
            false,
          ],
        },
        {
          label: "KNHS/FEI protokolo nuskaitymas",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "EPI (Performance Index)",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Varžybų kalendorius",
          values: [
            true,
            false,
            true,
            true,
            false,
          ],
        },
        {
          label: "Žedo portalas",
          values: [
            true,
            true,
            false,
            true,
            false,
          ],
        },
        {
          label: "Pamokų kortelė / abonementas",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Interneto mokėjimai",
          values: [
            true,
            false,
            false,
            true,
            false,
          ],
        },
        {
          label: "Integruotas žirgo dossier",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Kaustymo šerimininkas/veterinaras matomas",
          values: [
            true,
            false,
            false,
            false,
            false,
          ],
        },
        {
          label: "Instruktoriui ir žedui",
          values: [
            true,
            true,
            false,
            true,
            true,
          ],
        },
        {
          label: "Keli žirgai vienam žedui",
          values: [
            true,
            true,
            true,
            true,
            false,
          ],
        },
      ],
      note: "Palyginimas pagal viešai prieinamus funkcijas 2026 metų sausis mėnesį. EquiSight yra unikalus protokolo analitikoje ir EPI bei sujungia tai su bendru žirgo valdymu.",
    },
    why: {
      title: "Kodėl EquiSight suteikia kitokią trenerio patirtį.",
      lead: "Dauguma trenerio programų baigiasi ten, kur baigiasi pamoka. EquiSight toliau tęsiasi — žirgo dossier, varžybų analizė, bendradarbiavimas su veterinaru ir savininku.",
      points: [
        {
          icon: "TrendingUp",
          title: "Protokolo nuskaitymas → treniravimo tikslas",
          body: "Nuskaitykite KNHS protokolą ir iš karto pamatykite, kurie skyriai reikalingi dėmesiui. Tikslai atsiranda automatiškai.",
        },
        {
          icon: "Sparkles",
          title: "EquiCoach sustiprina jūsų žvilgsnį",
          body: "Duomenys iš kelių pamokų, varžybų ir protokolų rodo šablonus, kuriuos negalite išlaikyti savo galvoje.",
        },
        {
          icon: "Share2",
          title: "Integruota su žirgu",
          body: "Treneris mato žirgo vakcinacijas, kaušų priežiūrą ir traumų istoriją — neplanavo treniravimo per pasveikimą.",
        },
      ],
    },
    nicheA: {
      eyebrow: "Dresūrai ir šuoliams",
      title: "Ką coaching dossier EquiSight turi.",
      lead: "Kiekvienai kombinacijai gausite coaching srautą, kuris viską kaupia — neberašo keičiasi WhatsApp.",
      items: [
        "Pamokų pastabos su fokusuotais taškais per sesiją",
        "Ilgalaikiai tikslai ir šaltiniai",
        "Vaizdo nusiuntimas su laiko žyma komentarais",
        "KNHS/FEI protokolo nuskaitymas su taškais",
        "Žiuri komentarai susieti su treniravimo tikslu",
        "Varžybų rezultatai ir EPI tendencija",
        "Kliento kontaktas ir pamokų istorija",
        "Pamokų kortelė / abonementas / sąskaitos",
        "Pažangos grafikas pagal discipliną",
        "Dalinamoji prieiga su žirgo savininku",
      ],
      ctaLabel: "Peržiūrėti trenerio modulį",
      ctaHref: "/trainer",
    },
    beforeAfter: {
      title: "Iš WhatsApp + YouTube į EquiSight Trainer.",
      lead: "Konkrečiai: kaip keičiasi jūsų coaching darbo srautas.",
      rows: [
        {
          before: "WhatsApp su atsiskirtomis vaizdo nuorodomis",
          after: "Vaizdo su laiko žyma atsiliepimas dossier",
        },
        {
          before: "Sąsiuvinis kiekvienam žedui",
          after: "Coaching žurnalas su tikslais ir istorija",
        },
        {
          before: "Excel su varžybų rezultatais",
          after: "EPI grafikas ir protokolo analizė",
        },
        {
          before: "Žodiniai tikslai",
          after: "Šaltiniai su pažangos indikatoriumi",
        },
        {
          before: "Atskiras faktūravimo įrankis",
          after: "Pamokos + iDEAL + abonementas programoje",
        },
        {
          before: "Laiškas savininkui apie pažangą",
          after: "Savininkas seka savoje peržiūroje",
        },
      ],
    },
    helper: {
      title: "Kuri trenerio programa tinka jums?",
      lead: "5 klausimai, kad pamatytumėte, ar specializuota coaching programa naudinga jūsų praktikai.",
      questions: [
        {
          id: "clients",
          q: "Kiek aktyvių kombinacijų treniruoji?",
          options: [
            {
              label: "Mažiau nei 5",
              score: 1,
            },
            {
              label: "5-15",
              score: 2,
            },
            {
              label: "Daugiau nei 15",
              score: 3,
            },
          ],
        },
        {
          id: "discipline",
          q: "Kuri jūsų pagrindinė disciplina?",
          options: [
            {
              label: "Dresūra",
              score: 3,
            },
            {
              label: "Šuoliai",
              score: 2,
            },
            {
              label: "Rekreacinis / įvairuotas",
              score: 1,
            },
          ],
        },
        {
          id: "video",
          q: "Ar naudoji video coachingyje?",
          options: [
            {
              label: "Retai",
              score: 0,
            },
            {
              label: "Kartais (rankiniu būdu)",
              score: 2,
            },
            {
              label: "Dažnai — sistemingai",
              score: 3,
            },
          ],
        },
        {
          id: "comp",
          q: "Ar treniruoji varžybomis žedus?",
          options: [
            {
              label: "Ne, rekreacinis",
              score: 0,
            },
            {
              label: "Kartais varžybos",
              score: 2,
            },
            {
              label: "Daug — startines kortos centrinės",
              score: 3,
            },
          ],
        },
        {
          id: "depth",
          q: "Norite išmatuoti savo coachingą?",
          options: [
            {
              label: "Ne, intuicija pakanka",
              score: 0,
            },
            {
              label: "Taip, bet nėra laiko",
              score: 2,
            },
            {
              label: "Taip — duomenimis pagrindtas coaching",
              score: 3,
            },
          ],
        },
      ],
      results: {
        low: {
          title: "Paprastas įrankis ar net WhatsApp pakaks — kol kas.",
          body: "Mažiau nei 5 žedams be daug vaizdo ar varžybų coaching programa yra per daug. EquiSight pradeda nemokamai, todėl galite išbandyti, kai jūsų praktika augs.",
          cta: "Pradėti nemokamai",
        },
        mid: {
          title: "EquiSight Trainer padaro jus sistemingai efektyvesniais.",
          body: "Su 5-15 kombinacijomis, jūs mėnesį trankate laiką WhatsApp ir atskiriems vaizdo failams. EquiSight viską sujungia, nuskaito protokolus automatiškai ir žeda gali visada pamatyti savo atsiliepimus.",
          cta: "Išbandykite Trainer modulį",
        },
        high: {
          title: "EquiSight pastatytas jūsų coaching skalei.",
          body: "Daug žedų, vaizdo, varžybų ir duomenimis pagrindo coaching: tai tiksliai tai, kur EquiSight skiriasi. EPI + protokolo skenavimas + žirgo dossier suteikia jums pranašumą, kurio konkurentai neturi.",
          cta: "Planuokite demo savo coaching praktiką",
        },
      },
    },
    faqTitle: "Dažnai užduodami klausimai apie trenerio programas",
    faq: [
      {
        q: "Kuri geriausia trenerio programa žirgui ir žedui?",
        a: "Grynai komunikacijai daug programų pakaks (net WhatsApp). Tikslams, vaizdo analizei, protokolo skaitymui, varžybų sekimui ir kliento valdymui vienoje programoje EquiSight yra visapusiškiausia — ypač nes tai seka ir patį žirgą, ne tik kombinaciją.",
      },
      {
        q: "Ar EquiSight gali automatiškai skaityti varžybų protokolus?",
        a: "Taip. Nusiųskite KNHS ar FEI protokolą ir EquiSight išskiria taškus pagal dalį, žiuri komentarus ir susieja su kombinacija. Tendencijas matote per kelias varžybas.",
      },
      {
        q: "Kas yra EPI (Equestrian Performance Index)?",
        a: "EPI yra EquiSight balas, kuris kelis varžybų rezultatus paverčia lyginamąja veiklos indeksu. Tokiu būdu matote tikrą pažangą per skirtingus lygius ir žiuris.",
      },
      {
        q: "Ar žedai gali patys rezervuoti mano pamokas ir sumokėti?",
        a: "Taip. Žedai prisijungia, mato laisvus laiką, perka pamokų kortelę ir moka per iDEAL. Jūs patvirtinate, ką norite pasiūlyti.",
      },
      {
        q: "Ar tai veikia laisvajam treneriui, dirbandin aplink manėžą?",
        a: "Taip. Kaip nepriklausom treneris su savo klentais galite dirbti be manėžo sąskaitos. Klientai moka jums tiesiogiai.",
      },
      {
        q: "Ar galiu migruoti esamus vaizdo failą ir pastabas?",
        a: "Vaizdo failas galite nusiųsti pagal kombinaciją arba naudodami paketinį nusiuntimo įrankį. Pastabos importuojamos per CSV. Padedame aktyviems treneriams vienkartinę migraciją.",
      },
    ],
  },
  gidsen: {
    seo: {
      title: "Vedlaidžiai ir pasirinkimo pagalbos žirgo priežiūros programinei įrangai | EquiSight",
      description: "Visi EquiSight vedlaidžiai vienoje vietoje: žirgo priežiūra, veislėjimas, jojimo mokykla ir trenerio programos, taip pat pasirinkimo pagalbos 2026 metams.",
      keywords: [
        "žirgo programos vedlaidžiai",
        "žirgo priežiūros pasirinkimo pagalba",
        "veislėjimo programos palyginimas",
        "jojimo mokyklos programos vedlaidis",
        "trenerio programos palyginimas",
      ],
    },
    hub: {
      eyebrow: "Centras · vedlaidžiai",
      breadcrumbLabel: "Vedlaidžiai",
      title: "Keturi išsamūs vedlaidžiai, padėsiantys pasirinkti tinkamą žirgo programą.",
      intro: "Kiekvienai auditorijos grupei — išsami pasirinkimo pagalba: palyginimo lentelės, kriterijai, pavyzdžiai ir interaktyvus testas. Paspauskite vedlaidį, kuris jums tinka, arba iš pradžių išnagrinėkite išsamius straipsnius po kiekviena kategorija.",
      stats: {
        guides: "4 pasirinkimo pagalbos",
        articles: "15 išsamių straipsnių",
        fair: "Sąžingas palyginimas",
      },
      readMoreCta: "Skaityti visą vedlaidį",
      relatedHeading: "Išsamūs straipsniai",
      articlesCountSingular: "{{count}} išsamus straipsnis",
      articlesCountPlural: "{{count}} išsamūs straipsniai",
      articlesCountAria: "Kategorijos straipsnių skaičius",
      lastUpdatedPrefix: "Atnaujinta",
      lastUpdatedAria: "Šios kategorijos paskutinio atnaujinimo data",
    },
    clusters: [
      {
        path: "/beste-paardenbeheer-app",
        icon: "Compass",
        title: "Žirgo priežiūros programos pasirinkimo pagalba",
        blurb: "Palyginkite žinomuosius žirgo priežiūros programas ir sužinokite, kuri tinka savininku, staklei ar veislėjimui. Įskaitant sąžiningą palyginimo lentelę ir 5 klausimų pasirinkimo pagalbą.",
        audience: "Savininkams, stalpininkams ir visiems žirgo žmonėms, ieškantis apžvalgos.",
      },
      {
        path: "/fokkerij-software-paard",
        icon: "Baby",
        title: "Veislėjimo programos palyginimas",
        blurb: "Nuo meliuko ciklo iki žergo raidos: peržiūrėkite, kuri veislėjimo programa tikrai veikia jūsų melių skaičiui, veislėjimo metodui ir veislės reikalavimams.",
        audience: "Veislėjams (hobistams), veislės ūkiams ir žebrų laikymo savininkams.",
      },
      {
        path: "/manege-software",
        icon: "Building2",
        title: "Jojimo mokyklos programos pasirinkimo pagalba",
        blurb: "Pamokų planavimas, jojimu besiantys žmonės, savininko portalas ir sąskaita faktūra — viename įrankyje. Palyginkite parinktis jojimo mokykloms ir stalpams 2026 metais.",
        audience: "Jojimo mokykloms, stalpams ir jodinėjimo verslo įmonėms.",
      },
      {
        path: "/trainer-app-paard",
        icon: "Target",
        title: "Trenerio programos pasirinkimo pagalba",
        blurb: "Treniravimo CRM, vaizdo grįžtamasis ryšys, KNHS protokolo nuskaitymas ir tikslai kiekvienai kombinacijai. Kuri trenerio programa tinka jūsų treniravimo praktikai?",
        audience: "Instruktoriams, treneriams ir koučams.",
      },
    ],
    closing: {
      eyebrow: "Kodėl šie vedlaidžiai",
      title: "Sąžingas palyginimas, ne tik kainos.",
      body1: "Daugelis \"palyginimo puslapių\" yra maskuoti skelbimai. Mūsų vedlaidžiai šalia išdėsto funkcijas, tikslinę auditoriją ir konkurentus taip, kaip tai darytų nepriklausomas žinių šaltinis. EquiSight, žinoma, iškyla kaip išsami sprendimas, tačiau taip pat jūs skaitysite sąžiningai, kur kitos programos yra stipresnės.",
      body2: "Išsamūs straipsniai po kiekvienu vedlaičiu atsakys į konkrečius klausimus, kurie iškyla iš pasirinkimo: \"Kada pirmoji echoskopija po apvaisinimo\", \"Kaip automatizuoti jojimo mokyklos sąskaitas faktūras\", \"Kaip analizuoti varžybų protokolą\". Be rinkodaros nieko, tik praktika.",
    },
    hubName: "EquiSight Vedlaidžiai",
  },
  ui: {
    sectionEyebrows: {
      pains: "Kodėl tai skausminga",
      basics: "Pagrindai",
      criteria: "Kas daro tai geru?",
      comparison: "Sąžiningas palyginimas",
      why: "Skirtumas",
      beforeAfter: "Nuo chaoso iki aiškumo",
      helper: "5 klausimai",
    },
    table: {
      feature: "Funkcija",
      today: "Šiandien",
      withEquisight: "Su EquiSight",
    },
    helper: {
      questionLabel: "Klausimas {{current}} iš {{total}}",
      answerPrompt: "Atsakykite į likusį {{count}} klausimą, kad pamatytumėte rekomendaciją.",
      answerPromptPlural: "Atsakykite į likusius {{count}} klausimus, kad pamatytumėte rekomendaciją.",
      resultEyebrow: "Jūsų rezultatas",
    },
    targetGroupsFallback: "Kam tai skirta?",
    faqTitleFallback: "Dažniausiai užduodami klausimai",
  },
};

export default CORNERSTONES;
